module.exports = __webpack_public_path__ + "static/media/Status_Resolved.104e9ee2.svg";